<nav class="navbar">
    <!-- Logo a sinistra -->
    <div class="navbar-logo">
        <!-- Menu Burger rimosso da qui e spostato solo in versione mobile -->
        <div class="dropdown d-none d-md-block me-3">
            <button
                    type="button"
                    class="btn btn-burger"
                    id="menuDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    title="Menu Funzionalità">
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>
            <div class="dropdown-menu dropdown-menu-start menu-dropdown" aria-labelledby="menuDropdown">
                <div class="menu-grid">
                    <ng-container *ngFor="let item of menuItems">
                        <ng-container *ngIf="functionService.canRead(item.permission)">
                            <!-- Menu item principale -->
                            <div class="menu-item-wrapper">
                                <a
                                        class="dropdown-item menu-card"
                                        [class.active]="isCurrentRoute(item.route)"
                                        [class.has-submenu]="item.hasSubmenu"
                                        [class.expanded]="item.isExpanded"
                                        (click)="item.hasSubmenu ? toggleMenuExpansion(item, $event) : navigateToRoute(item.route)">
                                    <div class="menu-card-icon">
                                        <i [class]="item.icon"></i>
                                    </div>
                                    <div class="menu-card-content">
                                        <h6>{{ item.title | translate }}</h6>
                                    </div>
                                    <div class="menu-card-arrow">
                                        <i class="fas" [class.fa-chevron-down]="item.hasSubmenu && !item.isExpanded"
                                           [class.fa-chevron-up]="item.hasSubmenu && item.isExpanded"
                                           [class.fa-chevron-right]="!item.hasSubmenu"></i>
                                    </div>
                                </a>

                                <!-- Submenu espandibile -->
                                <div class="submenu" *ngIf="item.hasSubmenu && item.isExpanded">
                                    <ng-container *ngFor="let subItem of item.submenu">
                                        <a
                                                *ngIf="functionService.canRead(subItem.permission)"
                                                class="dropdown-item submenu-item"
                                                [class.active]="isCurrentRoute(subItem.route)"
                                                [routerLink]="subItem.route"
                                                (click)="navigateToSubmenu(subItem.route, $event)">
                                            <div class="submenu-item-icon">
                                                <i [class]="subItem.icon"></i>
                                            </div>
                                            <div class="submenu-item-content">
                                                <span>{{ subItem.title | translate }}</span>
                                            </div>
                                        </a>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Logo e testo Atlas separati-->
        <div class="logo-container">
            <a routerLink="/dashboard" [title]="'Vai alla dashboard'" aria-label="Dashboard">
                <ng-container *ngIf="showBertaniVGILogos">
                    <!-- <img src="img/logo_vgi.png" alt="Logo VGI" height="35px" loading="eager"> -->
                    <img src="img/CLT00001.jpg" alt="VGI" height="35px" loading="eager">
                    <img src="img/per.svg" alt="per" height="20px" style="padding-left:20px; padding-right:20px;">
                </ng-container>
                <img src="img/logo-bertani-color.svg" alt="Logo Merci Bertani" height="35px" loading="eager"
                     fetchpriority="high">
            </a>
            <!-- <a [routerLink]="['/about']" class="logo-text-link">
                <span class="logo-text">Atlas</span>
            </a> -->
        </div>

        <!-- <div class="navbar-logo snow-container">
             <a href="/dashboard" title="Dashboard">
                 <img
                         src="img/logo-bertani-color-winter.svg"
                         alt="Logo Merci Bertani"
                         height="35"
                         class="logo-img"
                 >
                 <canvas class="snow-canvas"></canvas>
             </a>
         </div> -->
    </div>

    <!-- Pulsante per toggle barra di ricerca (visibile solo su mobile) -->
    <!-- <button class="search-toggle d-md-none" type="button" aria-label="Toggle search" title="Mostra/Nascondi ricerca" (click)="toggleSearch()">
        <i class="fas fa-search"></i>
    </button> -->

    <div class="navbar-search" [ngClass]="{'expanded': isSearchExpanded}" style="display:none;">
        <form (submit)="performSearch($event)">
            <button class="btn-filter" type="button" aria-label="Filter button" title="Filtri Avanzati">
                <i class="fas fa-sliders-h"></i>
            </button>
            <select class="form-select border-none" aria-label="Search category" (change)="saveToLocalStorage($event)"
                    [value]="selectedCategory">
                <option value="products">{{ 'SEARCH.PARCELS' | translate }}</option>
                <option value="waybills">{{ 'SEARCH.WAYBILLS' | translate }}</option>
                <option value="orders">{{ 'SEARCH.ORDERS' | translate }}</option>
                <option value="customers">{{ 'SEARCH.CUSTOMERS' | translate }}</option>
                <option value="shipments">{{ 'SEARCH.SHIPMENTS' | translate }}</option>
                <option value="warehouse">{{ 'SEARCH.WAREHOUSE' | translate }}</option>
                <option value="suppliers">{{ 'SEARCH.SUPPLIERS' | translate }}</option>
            </select>
            <!-- Selettore di date -->
            <div class="date-input-wrapper" title="Data d'inizio">
                <i class="fas fa-calendar-alt"></i>
                <input type="text" id="startDateInput" class="date-input" placeholder="Inizio" readonly/>
            </div>
            <div class="date-input-wrapper" title="Data di fine">
                <i class="fas fa-calendar-alt"></i>
                <input type="text" id="endDateInput" class="date-input" placeholder="Fine" readonly/>
            </div>

            <input type="text" class="form-control" placeholder="{{ 'SEARCH.PLACEHOLDER' | translate }}"
                   aria-label="Search input" [(ngModel)]="searchInput" name="searchInput" (input)="saveSearchInput()"/>
            <button class="btn-reset" type="button" (click)="resetSearchInput()" title="Cancella">
                <i class="fas fa-times"></i>
            </button>
            <button class="btn-search" type="submit" title="Cerca">
                <i class="fas fa-search"></i>
            </button>
        </form>
    </div>

    <!-- Importa la libreria Font Awesome da URL -->
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">

    <!-- Pulsanti a destra visibili su desktop -->
    <div class="navbar-buttons desktop-menu">
        <!-- Sezione avvisi schedulati -->
        <div class="important-notice" *ngIf="activeNotice" [ngClass]="'notice-' + activeNotice.severity.toLowerCase()">
            <div class="notice-content">
                <i class="fas notice-icon"
                   [ngClass]="{
                     'fa-exclamation-triangle': activeNotice.severity === 'ERROR',
                     'fa-info-circle': activeNotice.severity === 'INFO',
                     'fa-exclamation-circle': activeNotice.severity === 'WARNING',
                     'fa-check-circle': activeNotice.severity === 'SUCCESS'
                   }"></i>
                <div class="notice-text-content">
                    <span class="notice-title" *ngIf="activeNotice.title">{{ activeNotice.title }}</span>
                    <span class="notice-message">{{ activeNotice.message }}</span>
                </div>
                <button class="notice-close" (click)="dismissNotice()" title="Chiudi avviso">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <!-- Menu a tendina per le lingue -->
        <!-- <div class="dropdown">
            <button class="btn btn-language dropdown-toggle" type="button" id="languageDropdown"
                    data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fas fa-globe"></i> <span>{{ 'NAVBAR.LANGUAGE' | translate }}</span>
            </button>
            <div class="dropdown-menu dropdown-menu-end language-dropdown" aria-labelledby="languageDropdown">
                <div class="language-grid">
                    <a class="dropdown-item" (click)="changeLanguage('it')">Italiano</a>
                    <a class="dropdown-item" (click)="changeLanguage('en')">English</a>
                    -- <a class="dropdown-item" (click)="changeLanguage('fr')"><span class="fi fi-fr flag-icon"></span> Français</a>
                    <a class="dropdown-item" (click)="changeLanguage('de')"><span class="fi fi-de flag-icon"></span> Deutsch</a>
                    <a class="dropdown-item" (click)="changeLanguage('es')"><span class="fi fi-es flag-icon"></span> Español</a>
                    <a class="dropdown-item" (click)="changeLanguage('pt')"><span class="fi fi-pt flag-icon"></span> Português</a>
                    <a class="dropdown-item" (click)="changeLanguage('nl')"><span class="fi fi-nl flag-icon"></span> Nederlands</a>
                    
                    <a class="dropdown-item" (click)="changeLanguage('pl')"><span class="fi fi-pl flag-icon"></span> Polski</a>
                    <a class="dropdown-item" (click)="changeLanguage('uk')"><span class="fi fi-ua flag-icon"></span> Українська</a>
                    <a class="dropdown-item" (click)="changeLanguage('ro')"><span class="fi fi-ro flag-icon"></span> Română</a>
                    <a class="dropdown-item" (click)="changeLanguage('sq')"><span class="fi fi-al flag-icon"></span> Shqip</a>
                    <a class="dropdown-item" (click)="changeLanguage('tr')"><span class="fi fi-tr flag-icon"></span> Türkçe</a>
                    <a class="dropdown-item" (click)="changeLanguage('ru')"><span class="fi fi-ru flag-icon"></span> Русский</a>
                    <a class="dropdown-item" (click)="changeLanguage('ar')"><span class="fi fi-sa flag-icon"></span> العربية</a>
                    
                    <a class="dropdown-item" (click)="changeLanguage('fa')"><span class="fi fi-ir flag-icon"></span> فارسی</a>
                    <a class="dropdown-item" (click)="changeLanguage('am')"><span class="fi fi-et flag-icon"></span> አማርኛ</a>
                    <a class="dropdown-item" (click)="changeLanguage('hi')"><span class="fi fi-in flag-icon"></span> हिन्दी</a>
                    <a class="dropdown-item" (click)="changeLanguage('bn')"><span class="fi fi-bd flag-icon"></span> বাংলা</a>
                    <a class="dropdown-item" (click)="changeLanguage('ur')"><span class="fi fi-pk flag-icon"></span> اردو</a>
                    <a class="dropdown-item" (click)="changeLanguage('zh')"><span class="fi fi-cn flag-icon"></span> 中文</a>
                    <a class="dropdown-item" (click)="changeLanguage('jp')"><span class="fi fi-jp flag-icon"></span> 日本語</a> --
                </div>
            </div>
        </div> -->

        <!--<a href="/tracking" class="btn btn-tracking">
            <i class="fas fa-map-marker-alt"></i> 
            <span>{{ 'NAVBAR.TRACKING' | translate }}</span>
        </a>
        
        <div class="dropdown">
            <button class="btn btn-notifications position-relative" type="button" id="notificationsDropdown"
                aria-expanded="false" data-bs-toggle="dropdown">
                <i class="fas fa-bell"></i>
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
                    3
                    <span class="visually-hidden">unread notifications</span>
                </span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="notificationsDropdown">
                <li><a class="dropdown-item" href="/notifications">
                    <i class="fas fa-bell text-primary"></i> {{ 'NAVBAR.NOTIFICATIONS' | translate }}</a>
                </li>
                <li><a class="dropdown-item" href="/alerts">
                    <i class="fas fa-exclamation-circle text-warning"></i> {{ 'NAVBAR.ALERTS' | translate }}</a>
                </li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li><a class="dropdown-item" href="/settings">
                    <i class="fas fa-cog"></i> {{ 'NAVBAR.NOTIFICATION_SETTINGS' | translate }}</a>
                </li>
            </ul>
        </div>-->

        <!-- <a href="/tracking" class="btn btn-tracking"><i class="fas fa-map-marker-alt"></i> <span>{{ 'NAVBAR.TRACKING' | translate }}</span></a> -->

        <div class="dropdown">
            <button class="btn btn-user" type="button" id="userDropdown" data-bs-toggle="dropdown"
                    aria-expanded="false">
                <i class="fas fa-user"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li><a class="dropdown-item" routerLink="/profile" *ngIf="functionService.canRead('profile')">
                    <i class="fas fa-id-card"></i> {{ 'NAVBAR.PROFILE' | translate }}</a>
                </li>
                <li><a class="dropdown-item" routerLink="/settings">
                    <i class="fas fa-cog"></i> {{ 'NAVBAR.SETTINGS' | translate }}</a>
                </li>
                <!-- <li>
                    <hr class="dropdown-divider">
                </li> -->
                <li><a class="dropdown-item" (click)="logout()">
                    <i class="fas fa-sign-out-alt"></i> {{ 'NAVBAR.LOGOUT' | translate }}</a>
                </li>
            </ul>
        </div>
    </div>

    <!-- Burger menu per mobile -->
    <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Toggle Menu">
        <i class="fas fa-bars"></i>
    </button>
</nav>

<!-- Menu mobile sotto la navbar -->
<div class="mobile-menu-container" [class.active]="mobileMenuOpen">
    <div class="mobile-menu-content">
        <!-- Menu principale -->
        <div class="mobile-menu-section">
            <div class="section-title">
                <i class="fas fa-th-large"></i> {{ 'NAVBAR.MENU_TITLE' | translate }}
            </div>
            <div class="mobile-menu-items">
                <ng-container *ngFor="let item of menuItems">
                    <ng-container *ngIf="functionService.canRead(item.permission)">
                        <!-- Menu item principale -->
                        <div class="mobile-menu-item-wrapper">
                            <a class="mobile-menu-item"
                               [class.has-submenu]="item.hasSubmenu"
                               [class.expanded]="item.isExpanded"
                               (click)="item.hasSubmenu ? toggleMenuExpansion(item, $event) : navigateToRoute(item.route); closeMobileMenuIfNoSubmenu(item)">
                                <div class="menu-item-icon">
                                    <i [class]="item.icon"></i>
                                </div>
                                <div class="menu-item-content">
                                    {{ item.title | translate }}
                                </div>
                                <div class="menu-item-arrow" *ngIf="item.hasSubmenu">
                                    <i class="fas" [class.fa-chevron-down]="!item.isExpanded"
                                       [class.fa-chevron-up]="item.isExpanded"></i>
                                </div>
                            </a>

                            <!-- Submenu espandibile -->
                            <div class="mobile-submenu" *ngIf="item.hasSubmenu && item.isExpanded">
                                <ng-container *ngFor="let subItem of item.submenu">
                                    <a *ngIf="functionService.canRead(subItem.permission)"
                                       class="mobile-submenu-item"
                                       (click)="navigateToSubmenu(subItem.route, $event); closeMobileMenu()">
                                        <div class="submenu-item-icon">
                                            <i [class]="subItem.icon"></i>
                                        </div>
                                        <div class="menu-item-content">
                                            {{ subItem.title | translate }}
                                        </div>
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <!-- Lingua -->
        <div class="mobile-menu-section">
            <div class="section-title">
                <i class="fas fa-globe"></i> {{ 'NAVBAR.LANGUAGE' | translate }}
            </div>
            <div class="language-grid-mobile">
                <a class="mobile-menu-item" (click)="changeLanguage('it'); closeMobileMenu()">Italiano</a>
                <a class="mobile-menu-item" (click)="changeLanguage('en'); closeMobileMenu()">English</a>
            </div>
        </div>

        <!-- Profilo e impostazioni -->
        <div class="mobile-menu-section">
            <div class="section-title">
                <i class="fas fa-user"></i> {{ 'NAVBAR.PROFILE' | translate }}
            </div>
            <div class="mobile-menu-items">
                <a class="mobile-menu-item" routerLink="/profile" *ngIf="functionService.canRead('profile')"
                   (click)="closeMobileMenu()">
                    <div class="menu-item-icon">
                        <i class="fas fa-id-card"></i>
                    </div>
                    <div class="menu-item-content">
                        {{ 'NAVBAR.PROFILE' | translate }}
                    </div>
                </a>
                <a class="mobile-menu-item" routerLink="/settings"
                   (click)="closeMobileMenu()">
                    <div class="menu-item-icon">
                        <i class="fas fa-cog"></i>
                    </div>
                    <div class="menu-item-content">
                        {{ 'NAVBAR.SETTINGS' | translate }}
                    </div>
                </a>
                <a class="mobile-menu-item" routerLink="/anagraphic" *ngIf="functionService.canRead('anagraphic')"
                   (click)="closeMobileMenu()">
                    <div class="menu-item-icon">
                        <i class="fas fa-address-book"></i>
                    </div>
                    <div class="menu-item-content">
                        Anagrafiche
                    </div>
                </a>
                <a class="mobile-menu-item logout" (click)="logout()">
                    <div class="menu-item-icon">
                        <i class="fas fa-sign-out-alt"></i>
                    </div>
                    <div class="menu-item-content">
                        {{ 'NAVBAR.LOGOUT' | translate }}
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>